module.exports = __webpack_public_path__ + "img/img-search03.b2666023.jpg";